import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import { useSiteTranslations } from "./use-site-translations";

// A Ready design's static thumbnail (the top of its home page on a phone, or on a desktop screen
// with `desktop`). `current` outlines it and adds the "Поточний" label; `crop` shows a shorter top
// part of the phone one, for small previews.
export function ReadyDesignThumb({
  uri,
  current = false,
  crop = false,
  desktop = false,
}: {
  uri: string | null | undefined;
  current?: boolean;
  crop?: boolean;
  desktop?: boolean;
}) {
  const { t } = useSiteTranslations();
  return (
    <SoftBox
      position="relative"
      width="100%"
      overflow="hidden"
      borderRadius="lg"
      sx={({ palette }) => ({
        aspectRatio: desktop ? "16 / 10" : crop ? "9 / 13" : "9 / 17",
        backgroundColor: palette.grey[200],
        border: current ? `2px solid ${palette.info.main}` : `1px solid ${palette.grey[300]}`,
      })}
    >
      {uri ? (
        <img
          src={uri}
          alt=""
          loading="lazy"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "top",
          }}
        />
      ) : null}
      {current ? (
        <SoftBox
          position="absolute"
          top={6}
          left={6}
          px={1}
          borderRadius="section"
          bgColor="info"
          lineHeight={1}
        >
          <SoftTypography variant="caption" fontWeight="bold" color="white">
            {t.designs.current}
          </SoftTypography>
        </SoftBox>
      ) : null}
    </SoftBox>
  );
}
